import styled from 'styled-components';

export const StyledBulkTitleWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]}px;
  margin-top: ${({ theme }) => theme.space[4]}px;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
`;
